<template>

  <div class="page">

    <div class="top"></div>

  <!-- block开始 -->
  <div class="content-block">
  
    <div class="main">

      <div class="bg">
        <div class="img" :style="{backgroundImage:'url(' + bgColor2 + ')'}"><img :src="resultImg2" /></div>
        <div class="tp1 p1">{{ textArray2.p1 }}</div>
        <div class="tp1 p2">{{ textArray2.p2 }}</div>
        <div class="tp2 p3">{{ textArray2.p3 }}</div>
        <div class="tp2 p4" v-html="textArray2.p5"></div>
      </div>

    </div>

    <div class="save">
      <img :src="posterImg" />
    </div>

    <div class="btns">
      <div class="btn lottery" @click="guide"></div>
      <div class="btn home" @click="back"></div>
    </div>

    <div class="tip"></div>

    <vue-canvas-poster
      :widthPixels="750"
      :painting="painting"
      @success="success"
      @fail="fail"
    ></vue-canvas-poster>

    <van-popup v-model="show">
      <div class="popup">
        <!-- <a href="javascript:;" class="yes" @click="back"></a>
        <a href="javascript:;" class="no" @click="close"></a> -->
      </div>
    </van-popup>

  </div>
  <!-- block结束 -->

  </div>

</template>

<script>
import { getStore } from "@/util/store";
import { VueCanvasPoster } from 'vue-canvas-poster'
import wxApi from '@/util/wxapi';
import { getShare} from "@/api/index";
export default {
  props: ['resultImg','textArray','nameImg','bgColor'],
  data() {
    return {
      show: false,
      posterImg: '',

      resultImg2: this.resultImg,
      textArray2: this.textArray,
      nameImg2: this.nameImg,
      bgColor2: this.bgColor
    };
  },
  components: {
    VueCanvasPoster
  },
  created() {
    let url = location.href.split('#')[0];
    console.log(url);
    getShare({ url }).then((res) => {
      let data = res.data
      // let link = location.href.split('?')[0];
      let link = 'https://mmk.wepie.cc/minions/';
      let option = {
        title: '测测你的不乖因子',
        link: link,
        imgUrl: link+'share.png',
        desc: '这里有一份属于你的不乖奖赏',
        success: this.share
      }
      console.log(data);
      console.log(option)
      wxApi.wxRegister(data, option);
    })
  },
  mounted() {
    // console.log(this.resultImg)
    // console.log(this.textArray)
    // console.log(this.nameImg)
    // console.log(this.bgColor)
    this.resultImg2 = this.resultImg2 ? this.resultImg2 : getStore({ name: "resultImg" })
    this.textArray2 = this.textArray2 ? this.textArray2 : getStore({ name: "textArray" })
    this.nameImg2   = this.nameImg2 ? this.nameImg2 : getStore({ name: "nameImg" })
    this.bgColor2   = this.bgColor2? this.bgColor2 : getStore({ name: "bgColor" })

    // this.resultImg = this.resultImg ? this.resultImg : getStore({ name: "resultImg" })
    // this.textArray = this.textArray ? this.textArray : getStore({ name: "textArray" })
    // this.nameImg   = this.nameImg ? this.nameImg : getStore({ name: "nameImg" })
    // this.bgColor   = this.bgColor ? this.bgColor : getStore({ name: "bgColor" })
    
    // console.log(this.resultImg2)
    // console.log(this.textArray2)
    // console.log(this.nameImg2)
    // console.log(this.bgColor2)
  },
  computed: {
    painting() {
      return {
        width: '1500px',
        height: '3000px',
        background: require('@/images/result/poster-bg.jpg'),
        views: [
          {
            type: 'image',
            url: this.nameImg2,
            css: {
              top: '2620px',
              left: '428px',
              width: 'auto',
              height: '120px',
              mode: 'aspectFill'
            }
          },
          {
            type: 'image',
            url: this.bgColor2,
            css: {
              top: '206px',
              left: '164px',
              borderRadius: '25px',
              width: '1180px',
              height: '1180px'
            }
          },
          {
            type: 'image',
            url: this.resultImg2,
            css: {
              top: '206px',
              left: '164px',
              borderRadius: '25px',
              width: '1180px',
              height: '1180px'
            }
          },
          {
            type: 'text',
            text: this.textArray2.p1,
            css: [
              {
                width: '700px',
                lineHeight: '64px',
                textAlign: 'center',
                top: '1512px',
                left: '416px',
                fontFamily: 'zpix',
                src: require('@/font/zpix.ttf'),
                fontSize: '40px',
                color: '#ffda02',
              }
            ]
          },
          {
            type: 'text',
            text: this.textArray2.p2,
            css: [
              {
                width: '1180px',
                lineHeight: '64px',
                textAlign: 'center',
                top: '1586px',
                left: '164px',
                fontFamily: 'zpix',
                src: require('@/font/zpix.ttf'),
                fontSize: '40px',
                color: '#ffda02'
              }
            ]
          },
          {
            type: 'text',
            text: this.textArray2.p3,
            css: [
              {
                width: '864px',
                lineHeight: '70px',
                textAlign: 'left',
                top: '1898px',
                left: '330px',
                fontFamily: 'bmjh',
                src: require('@/font/bmjh.ttf'),
                fontSize: '56px',
                textStyle: 'italic',
                color: '#ffda02'
              }
            ]
          },
          {
            type: 'text',
            text: this.textArray2.p4,
            css: [
              {
                width: '864px',
                lineHeight: '64px',
                textAlign: 'left',
                top: '2058px',
                left: '330px',
                fontFamily: 'bmjh',
                src: require('@/font/bmjh.ttf'),
                fontSize: '48px',
                textStyle: 'italic',
                color: '#ffffff'
              }
            ]
          },
        ]
      }
    }
  },
  methods: {
    // 弹窗
    // showPopup() {
    //   this.show = true;
    // },
    close() {
      this.show = false;
    },
    success(src) {
      // console.log(src)
      this.posterImg = src
    },
    fail(err) {
      console.log('fail', err)
    },
    // 分享回调
    share() {
      this.$emit("share");
    },
    // 分享引导
    guide() {
      console.log('guide')
      this.show = true;
    },
    // 返回首页
    back() {
      this.$emit("back");
    }
  },
};
</script>

<style scoped lang="less">
.van-popup {
  background-color: transparent;
  .popup {
    width: 635px;
    height: 274px;
    background: transparent url("../images/result/layer-share.png") center center no-repeat;
    background-size: 100%;
    position: relative;
  }
}
.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
  .content-block {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1200px;
    top: 50%;
    margin-top: -600px;
  }
  .save {
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    -webkit-touch-callout: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    // left: 100px;
    width: 542px;
    height: 46px;
    background: url("../images/result/tip2.png") no-repeat;
    background-size: 100%;
  }
  .btns {
    z-index: 5;
    position: absolute;
    bottom: 5%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 540px;
    height: 75px;
    text-align: center;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .btn {
      width: 247px;
      height: 75px;
    }
    .share {
      background: url("../images/result/btn-share.png") no-repeat;
      background-size: 100%;
    }
    .lottery {
      background: url("../images/result/btn-lottery.png") no-repeat;
      background-size: 100%;
    }
    .home {
      background: url("../images/result/btn-home.png") no-repeat;
      background-size: 100%;
    }
  }
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../images/title.png") no-repeat;
  background-size: 100%;
}
.main {
  z-index: 3;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 10%;
  // bottom: 5%;
  margin: 0 auto;
  box-sizing: border-box;
  .bg {
    width: 590px;
    height: 948px;
    background: url("../images/bg/bg-result.png") no-repeat;
    background-size: 100%;
    margin: 0 auto 0px;
    .img {
      // border: 1px solid red;
      position: absolute;
      top: 28px;
      left: 116px;
      // right: 0;
      // margin: 0 auto;
      width: 515px;
      height: 515px;
      box-sizing: border-box;
      background-size: 515px;
      border-radius: 25px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 25px;
      }
    }
    .tp1 {
      font-family: 'zpix';
      position: absolute;
      color: #ffda02;
      width: 520px;
      height: 32px;
      line-height: 32px;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align: center;
      font-size: 20px;
      -webkit-user-select: none;
    }
    .p1 {
      top: 594px;
    }
    .p2 {
      top: 626px;
    }
    .tp2 {
      font-family: 'bmjh';
      position: absolute;
      color: #ffda02;
      width: 360px;
      height: 70px;
      line-height: 35px;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align: left;
      font-size: 24px;
      // font-weight: bold;
      font-style: italic;
      font-weight: normal;
      -webkit-user-select: none;
    }
    .p3 {
      top: 760px;
    }
    .p4 {
      top: 832px;
      color: #FFF;
      font-size: 20px;
      line-height: 30px;
    }
  }
}
</style>
